import React, { useContext, useState } from "react";
import Testimonial from "./testimonial";
import ArrowLeft from "./arrow-left-icon";
import Info from "./info-icon";
import LocationInput from "./location-input";
import GettingStartedContext from "../utils/GettingStartedContext";
import QuestionsIntro from "../components/questions-intro";
const link = $("#root").data("link");

const LOCATION_Q_CLASS = "App\\Model\\DepartureLocationQuestion";

const QuestionDetail = () => {
    const {
        link,
        data,
        setData,
        getLink,
        getProperty,
        langString,
        question,
        setQuestion,
        submittedQuestions,
        indexOfSubmittedQuestion,
        selectTestimonials,
        setSubmittedQuestions,
        showSkip,
        showResult,
        setShowResult,
        padLeadingZeros,
        setLocation,
        getNextQuestion,
        setPlane,
        setPlan,
        setHours,
        location,
        showFooter,
    } = useContext(GettingStartedContext);

    const [processing, setProcessing] = useState(false);
    const [currentOption, setCurrentOption] = useState(null);

    const mergeTag = (txt) => {
        let text = txt;
        const re = text.match(/(\bQRef\S+\b)/gi);
        if (re && re.length) {
            let ref = re[0];
            let option = getMatchingAnswer(ref, "Reference");
            let answer =
                typeof option === "object" &&
                option !== null &&
                (getProperty(option, "Reference") != "" ||
                    getProperty(option, "Reference") != "undefined")
                    ? mergeTag(option.Title)
                    : typeof option !== "object"
                    ? option
                    : "";
            text = text.replaceAll(ref, answer);
        }
        const res = text.match(/(\bARef\S+\b)/gi);
        if (res && res.length) {
            let ref = res[0];
            let option = getMatchingAnswer(ref, "AnsReference");
            let answer =
                typeof option === "object" &&
                option !== null &&
                getProperty(option, "NextQTitle") != undefined
                    ? mergeTag(option.NextQTitle)
                    : "";
            text = text.replaceAll(ref, answer);
        }
        return text;
    };

    const getMatchingAnswer = (ref, refType) => {
        for (let question of submittedQuestions) {
            if (getProperty(question, refType)) {
                if (question.refType === ref) {
                    return question.Option;
                }
            }
        }
        return null;
    };

    const showTooltip = (object, property) => {
        return null;
    };

    const answerQuestion = () => {
        const next = getNextQuestion(question);
        // TODO check for current option is answered
        if (question.ClassName === LOCATION_Q_CLASS) {
            setLocation(currentOption);
        }

        question.Option = currentOption;
        const queue = [...submittedQuestions, question];
        setSubmittedQuestions(queue);
        selectTestimonials();
        if (next) {
            setCurrentOption(null);
            setQuestion(next);
        } else {
            window.setTimeout(() => {
                getResult(queue);
            }, 100);
        }
    };

    const getResult = (queue) => {
        setProcessing(true);
        const answers = [];
        for (const aQ of queue) {
            if (aQ.ClassName === LOCATION_Q_CLASS) {
                answers.push({
                    Class: aQ.ClassName,
                    Question: {
                        Description: aQ.Description,
                    },
                    Option: location,
                });
            } else {
                answers.push({
                    Class: aQ.ClassName,
                    Option: {
                        ID: aQ.Option.ID,
                        ClassName: aQ.Option.ClassName,
                        Code: aQ.Option.Code,
                    },
                });
            }
        }

        fetch(getLink("getResults"), {
            method: "POST",
            body: JSON.stringify({
                answers: answers,
            }),
        })
            .then((response) => response.json())
            .then((json) => {
                if (!json.BestPlane) {
                    json.BestPlane = json.Plane;
                }
                if (!json.BestOwnership) {
                    json.BestOwnership = json.Ownership;
                }

                const options = {
                    ...data.Options,
                    ...json,
                };

                setData({
                    ...data,
                    Options: options,
                });

                setPlan(json.BestPlan);
                setHours(json.BestPlan.ID);
                setPlane(json.BestPlane.ID);
                setShowResult(true);
                setProcessing(false);
                // setShowSkip(false);
                showFooter();

                // if (!json.BestPlane) {
                //   json.BestPlane = json.Plane;
                // }
                // if (!json.BestOwnership) {
                //   json.BestOwnership = json.Ownership;
                // }
                //
                // const options = {
                //   ...data.Options,
                //   ...json
                // }
                //
                // setData({
                //   ...data,
                //   Options: options
                // });
                //
                // // setPlan(json.BestPlan ? json.BestPlan : json.Plan);
                // // setHours(json.BestPlan ? json.BestPlan.ID : json.Plan.ID);
                // // setShowResult(true);
                // showFooter();
            });
    };

    return (
        <>
            {!question && !showSkip && !showResult && <QuestionsIntro />}
            {!!question && (
                <>
                    <div className="grid-container">
                        {!!question.Title && (
                            <>
                                <h4 className="gsa__form__step">
                                    <span className="gsa__form__step-number">
                                        {padLeadingZeros(question.Pos + 1, 2)} /{" "}
                                        {padLeadingZeros(data.QuestionCount, 2)}
                                    </span>
                                    &nbsp; {mergeTag(question.Title)}
                                </h4>
                            </>
                        )}
                        {!!question.Description && (
                            <h2 className="gsa__form__question">
                                {mergeTag(question.Description)}
                            </h2>
                        )}

                        {!!question.Options.length > 0 && (
                            <>
                                <div className="gsa__form-option gsa__form-radio-option">
                                    <ul>
                                        {question.Options.map((o, index) => {
                                            return (
                                                <li key={o.ID}>
                                                    <input
                                                        type="radio"
                                                        id={
                                                            question.ID +
                                                            "-" +
                                                            index
                                                        }
                                                        name="option"
                                                        // value={o.ID}
                                                        onChange={() => {
                                                            setCurrentOption(o);
                                                            const q = {
                                                                ...question,
                                                            };
                                                            q.Option = o;

                                                            setQuestion(q);
                                                            selectTestimonials();
                                                        }}
                                                        checked={
                                                            currentOption &&
                                                            currentOption.ID ===
                                                                o.ID
                                                        }
                                                    />
                                                    <label
                                                        htmlFor={
                                                            question.ID +
                                                            "-" +
                                                            index
                                                        }
                                                    >
                                                        {mergeTag(o.Title)}
                                                        {showTooltip(
                                                            o,
                                                            "Tooltip"
                                                        )}
                                                    </label>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    {!!question.Information && (
                                        <div className="gsa__form-desc">
                                            <Info />
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mergeTag(
                                                        question.Information
                                                    ),
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        )}

                        {question.ClassName === LOCATION_Q_CLASS && (
                            <>
                                <div className="gsa__form-option gsa__form-text">
                                    <div className="gsa__form-input">
                                        <LocationInput
                                            setCurrentOption={setCurrentOption}
                                            placeHolder={langString(
                                                "ENTER_YOUR_LOCATION"
                                            )}
                                        />
                                        <button
                                            className="gsa__form-button button secondary"
                                            id={`NextQ_` + question.ID}
                                            onClick={() => answerQuestion()}
                                        >
                                            <span>
                                                {question.ButtonText}
                                                <ArrowLeft />
                                            </span>
                                        </button>
                                    </div>
                                    {!!question.Information && (
                                        <div className="gsa__form-desc">
                                            <Info />
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mergeTag(
                                                        question.Information
                                                    ),
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        )}

                        {!!question.ShowTestimonial && <Testimonial />}

                        {question.ClassName !== LOCATION_Q_CLASS && (
                            <>
                                <p className="gsa__form-button-container text-center bottom">
                                    <button
                                        className="gsa__form-button button secondary"
                                        id={`NextQ_` + question.ID}
                                        onClick={() => answerQuestion()}
                                    >
                                        <span>{question.ButtonText}</span>
                                    </button>
                                </p>
                            </>
                        )}

                        {!!processing && (
                            <div className="loader-container">
                                <div className="loader"></div>
                                <span>Please wait..</span>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default QuestionDetail;
